export enum VisibilityLevels {
  currentPeriod,
  pinned,
  recurring,
}
